export default function auth ({ next, store }){
    if(store.getters.auth_token !== null){
        return next({
            name: 'empresas'
        })
    }

    return next()
}